import { onDeletePaymentConfig } from 'redux/payment-configuration/saga/deletePaymentConfig';
import { getAllPaymentConfig } from 'redux/payment-configuration/saga/fetchAllPaymentConfig';
import {
  getInterswitchConfig,
  getNabrollConfig,
  getPayproKanoConfig,
  getPaystackConfig,
  getPayUnimaidConfig,
  getRemitaConfig,
} from 'redux/payment-configuration/saga/fetchEachPaymentConfig';
import { onImportPaymentConfig } from 'redux/payment-configuration/saga/importPaymentConfig';
import { onUpdatePaymentConfig } from 'redux/payment-configuration/saga/updatePaymentConfig';
import { onUpdatePlatformChargeStatus } from './updatePaylogChargeStatus';

import { all, call } from 'redux-saga/effects';

export default function* groupsSaga() {
  yield all([
    call(getAllPaymentConfig),
    call(getPaystackConfig),
    call(getNabrollConfig),
    call(getPayproKanoConfig),
    call(getPayUnimaidConfig),
    call(getRemitaConfig),
    call(getInterswitchConfig),
    call(onImportPaymentConfig),
    call(onDeletePaymentConfig),
    call(onUpdatePaymentConfig),
    call(onUpdatePlatformChargeStatus),
  ]);
}
